import React from "react";
import ListStatus from "../../components/controls/ListStatus";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.warn("ErrorBoundary caught:", error, info);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || (
                <div className="mt-3">
                    <ListStatus error={true} errorText={"OTM_ERROR_LOADING_PAGE"} />
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;